import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { LabelWithToolTip } from "../../../../atoms/LabelWithToolTip";
import Select from "react-select";
import LockFieldsButton from "../../../../molecules/LockFieldsButton";

const SwiftForm = (props) => {
    return (
    <>
      {/* Purpose */}
      <FormGroup>
        <LabelWithToolTip
          id="labelPurpose"
          labelText="Purpose *"
          tooltipText="How this account will be used: Payroll = salary payments; Expenditure = expenses and reimbursements; All = both payroll and expenditure."
        />
        <Select
          value={props.purpose ? props.purposeOption.find((item) => item.value === props.purpose) : null}
          onChange={(e) => props.setPurpose(e?.value)}
          options={props.purposeOption}
          placeholder="Select..."
        />
      </FormGroup>

      {/* Currency and Keep This Only fields */}
      <Row>
        <Col sm="12" md="6">
          <FormGroup>
            <LabelWithToolTip
              id="labelCurrency"
              labelText="Currency *"
              tooltipText="Select the currency for this bank account"
            />
            <select
              {...props.register("currencyId")}
              className="form-control"
              name="currencyId"
              value={
                props.currencyList?.find((c) => c.currencyCode === props.currency)?.id || ""
              }
              onChange={props.onCurrencyChanged}
            >
              {(props.sortedCurrencyList || []).map((currency, index) => (
                <option key={currency.id} value={currency.id}>
                  {currency.currencyCode}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
      </Row>


      {/* Account Number Field */}
      <Row>
        <Col sm="12">
          <FormGroup>
            <LabelWithToolTip
              id="labelAccountNumber"
              labelText="Account Number *"
              tooltipText="Bank account number as it appears on your bank statement. Maximum 50 characters. Only alphanumeric characters and spaces allowed. Hyphens (-) are not permitted."
            />
            <input
              type="text"
              {...props.register("bankAccountNumber")}
              value={props.bankAccountNumber}
              onChange={props.handleAccountNo}
              maxLength={34}
              className="form-control"
            />
          </FormGroup>
        </Col>
      </Row>

      {/* Beneficiary Name Field */}
      <Row>
        <Col sm="12">
          <FormGroup>
            <LabelWithToolTip
              id="labelBeneficiaryName"
              labelText="Beneficiary Name *"
              tooltipText="Name of the account holder as it appears on the bank account. 
              Only alphanumeric characters, spaces, parentheses, commas and periods. Ampersands (&) are not permitted."
            />
            <input
              type="text"
              {...props.register("beneficiaryBankAccountName", { required: true })}
              value={props.beneficiaryName}
              onChange={props.onBeneficiaryNameChange}
              maxLength="100"
              className="form-control"
            />
            
          </FormGroup>
        </Col>
      </Row>


      {/* SWIFT/BIC Field */}
      <Row>
        <Col sm="12">
          <FormGroup>
            <LabelWithToolTip
              id="labelSwift"
              labelText="Beneficiary Bank SWIFT BIC *"
              tooltipText="Bank Identifier Code (BIC/SWIFT). Must be 8 or 11 characters. Only alphanumeric characters allowed (e.g., BUKBGB22)."
            />
            <input
              type="text"
              name="bic"
              value={props.bic || ""}
              onChange={(e) => props.setValue("bic", e.target.value)}
              className="form-control"
            />
            
          </FormGroup>
        </Col>
      </Row>


      {/* Corresponding BIC SWIFT Field */}
      <Row>
        <Col sm="12">
          <FormGroup>
            <LabelWithToolTip
              id="labelCorrespondingBic"
              labelText="Corresponding Bank SWIFT BIC"
              tooltipText="Intermediary bank SWIFT code if payments need to be routed through another bank (optional). 
              Must be 8 or 11 characters if provided. Only alphanumeric characters allowed."
            />
            <input
              type="text"
              name="correspondingBic"
              value={props.correspondingBic || ""}
              onChange={(e) => props.setValue("correspondingBic", e.target.value)}
              className="form-control"
            />
          </FormGroup>
        </Col>
      </Row>

      {/* Auto-filled fields - only visible if bank selected from MyHR OR after manual SWIFT validation */}
      {(props.selectedBankFromMyHR || props.isBicValidated) && (
        <>
          {/* Lock/Unlock Button */}
          <LockFieldsButton allowEdit={props.allowEdit} setAllowEdit={props.setAllowEdit} />

          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="bank">Bank</Label>
                <input
                  type="text"
                  {...props.register("bankName", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isBicValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="branch">Branch</Label>
                <input
                  type="text"
                  {...props.register("branch", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isBicValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="address">Bank Address</Label>
                <input
                  type="text"
                  {...props.register("bankAddress", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isBicValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="city">City</Label>
                <input
                  type="text"
                  {...props.register("bankCity", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isBicValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="zip">Zip</Label>
                <input
                  type="text"
                  {...props.register("bankZip", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isBicValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="country">Country</Label>
                <input
                  type="text"
                  {...props.register("bankCountry", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isBicValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>

          {/*Country Code Field */}
          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="isoCountryCode">Country Code</Label>
                <input
                  type="text"
                  value={props.isoCountryCode || ""}
                  onChange={(e) => props.onCountryCodeChange && props.onCountryCodeChange(e.target.value)}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isBicValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>
        </>
      )}

    </>
  );
};

export default SwiftForm;
